import { TaskRunErrorCodes, } from "../schemas/index.js";
export class NoopRuntimeManager {
    disable() {
        // do nothing
    }
    waitForDuration(ms) {
        return Promise.resolve();
    }
    waitUntil(date) {
        return Promise.resolve();
    }
    waitForTask(params) {
        return Promise.resolve({
            ok: false,
            id: params.id,
            error: {
                type: "INTERNAL_ERROR",
                code: TaskRunErrorCodes.CONFIGURED_INCORRECTLY,
            },
        });
    }
    waitForBatch(params) {
        return Promise.resolve({
            id: params.id,
            items: [],
        });
    }
}
//# sourceMappingURL=noopRuntimeManager.js.map